<template>
  <v-container>
    <v-dialog
      v-if="dialogs.user"
      v-model="dialogs.user"
      :fullscreen="this.$vuetify.breakpoint.xs"
      max-width="500"
    >
      <user
        :user="user"
        :locations="locations"
        :canDelete="canDeleteUser"
        :isAdmin="canAdd"
        v-on:close="dialogs.user = false"
      ></user>
    </v-dialog>
    <v-dialog
      v-if="dialogs.location"
      v-model="dialogs.location"
      :fullscreen="this.$vuetify.breakpoint.xs"
      max-width="500"
    >
      <location
        :location="location"
        :canDelete="canDeleteLocation"
        v-on:close="dialogs.location = false"
      ></location>
    </v-dialog>

    <v-row>
      <v-col cols="12" md="6">
        <v-subheader class="subheading">
          Users
          <v-spacer></v-spacer>
          <v-btn
            fab
            :dark="canAdd"
            x-small
            class="mt-0"
            color="blue"
            :disabled="!canAdd"
            @click="newUser()"
          >
            <font-awesome-icon size="lg" icon="plus" />
          </v-btn>
        </v-subheader>
        <v-divider></v-divider>
        <v-list subheader three-line>
          <!-- <v-subheader>Hangout notifications</v-subheader> -->
          <v-list-item
            v-for="(item, index) in users"
            :key="index"
            @click="viewUser(item)"
          >
            <v-list-item-content>
              <v-list-item-title>{{ item.name }}</v-list-item-title>
              <v-list-item-subtitle>{{ item.email }}</v-list-item-subtitle>
              <v-list-item-subtitle>{{
                locationName(item.defaultLocation)
              }}</v-list-item-subtitle>
            </v-list-item-content>

            <v-list-item-action>
              <v-chip
                v-if="currentUser._id === item._id"
                text-color="white"
                label
                color="success"
                class="text-uppercase"
                >Current</v-chip
              >
            </v-list-item-action>
            <v-list-item-action>
              <v-chip
                label
                :text-color="item.role !== 'user' ? 'white' : 'black'"
                :color="item.role !== 'user' ? 'secondary' : 'buttonGrey'"
                class="text-uppercase"
                >{{ item.role }}</v-chip
              >
            </v-list-item-action>
          </v-list-item>
        </v-list>
      </v-col>
      <v-col cols="12" md="6">
        <v-subheader class="subheading">
          Locations
          <v-spacer></v-spacer>
          <v-btn
            fab
            :dark="canAdd"
            x-small
            class="mt-0"
            color="blue"
            :disabled="!canAdd"
            @click="newLocation()"
          >
            <font-awesome-icon size="lg" icon="plus" />
          </v-btn>
        </v-subheader>
        <v-divider></v-divider>
        <v-list subheader three-line>
          <!-- <v-subheader>Hangout notifications</v-subheader> -->
          <v-list-item
            v-for="(item, index1) in locations"
            :key="index1"
            @click="viewlocation(item)"
            :disabled="item.name === 'Demo'"
          >
            <v-list-item-content>
              <v-list-item-title>{{ item.name }}</v-list-item-title>
              <v-list-item-subtitle
                >{{ item.address }}, {{ item.city }},
                {{ item.postcode }}</v-list-item-subtitle
              >
              <v-list-item-subtitle
                >{{ item.phone }} | {{ item.email }}</v-list-item-subtitle
              >
            </v-list-item-content>

            <v-list-item-action>
              <v-chip
                v-if="defaultLocation === item._id"
                label
                text-color="white"
                color="secondary"
                class="text-uppercase"
                >DEFAULT</v-chip
              >
            </v-list-item-action>
          </v-list-item>
        </v-list>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapActions } from "vuex";

import user from "./user";
import location from "./location";

export default {
  components: {
    user,
    location,
  },
  data() {
    return {
      showAPIKey: false,
      user: null,
      location: null,
      dialogs: {
        user: false,
        location: false,
      },
    };
  },
  methods: {
    ...mapActions({
      getUsers: "account/getUsers",
    }),
    locationName(id) {
      var location = this.locations.find((l) => {
        return l._id == id;
      });
      if (location) {
        return location.name;
      } else {
        return "";
      }
    },
    viewUser(item) {
      this.user = {
        ...item,
      };

      if (this.canEditUser) {
        this.dialogs.user = true;
      }
    },
    newUser() {
      this.user = {
        name: "",
        email: "@sure-grp.co.uk",
        password: "Sure21!!",
        role: "user",
        confirmPassword: "Sure21!!",
        defaultLocation: this.defaultLocation,
      };

      if (this.canAdd) {
        this.dialogs.user = true;
      }
    },

    viewlocation(item) {
      this.location = {
        ...item,
      };
      if (this.canEditLocation) {
        this.dialogs.location = true;
      }
    },
    newLocation() {
      this.location = {
        address: "",
        city: "",
        postcode: "",
        locationName: "",
        phone: "",
        email: "",
        prefix: "",
      };
      if (this.canAdd) {
        this.dialogs.location = true;
      }
    },
  },
  computed: {
    ...mapState({
      account: (state) => state.account,
    }),
    canAdd() {
      return this.currentUser.role !== "user";
    },
    canEditUser() {
      return (
        this.user._id == this.currentUser._id ||
        this.currentUser.role !== "user"
      );
    },
    canDeleteUser() {
      return (
        this.user.role == "user" ||
        (this.user.role !== "user" && this.admins.length > 1)
      );
    },
    canEditLocation() {
      return this.currentUser.role !== "user";
    },
    canDeleteLocation() {
      return (
        this.locations.length > 1 && this.location._id != this.defaultLocation
      );
    },
    defaultLocation() {
      return this.currentUser.defaultLocation;
    },
    currentUser() {
      return this.account.user;
    },
    admins() {
      return this.users.filter((user) => {
        return user.role !== "user";
      });
    },
    users() {
      return this.account.users;
    },
    locations() {
      return this.account.locations;
    },
  },
  mounted() {
    this.getUsers();
  },
};
</script>
